import styled from '@emotion/styled'
import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'

interface AttributeOverridesTableValueCellProps {
  displayValue: string
}

const CellText = styled(({ children, ...props }) => (
  <Text {...props} title={children}>
    {children}
  </Text>
))({
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export const AttributeOverridesTableValueCell: FunctionComponent<
  AttributeOverridesTableValueCellProps
> = ({ displayValue }) => <CellText>{displayValue}</CellText>
